import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../utils/redux-forms-custom-fields/CustomInput';
// import RichText from '../../../../utils/RichText';
import {DATE_DISPLAY_FORMAT, DATE_STORE_FORMAT} from "../constants/dateFormats";
import CustomDateTimePicker from "../../../../utils/redux-forms-custom-fields/CustomDateTimePicker";
// import moment from "moment/moment";

const DropActivitys = ({
  fields,
  onRemove,
  onRichTextUpdate
}) => {
  // const fieldValues = fields.getAll();
    const dateDisplayFormat = 'MM-DD-YYYY HH:mm'; // 本地显示格式

    const handleStartChange = (value,index) => {
      onRichTextUpdate(value, `activitys[${index}].startDateTime`)
        // const { isNewTypeQuest } = this.getQuestTypeFlags();
        // console.log('handleStartChange 收到值:', value);
        //
        // if (isNewTypeQuest) {
        //     // 不需要进行时区转换，因为在 CustomDateTimePicker 组件中已经处理过
        //     this.props.change('openRegistrationDate', value);
        // }
    }

    // 当结束时间改变时，将 closeRegistrationDate 更新为相同的值，并将 expectedPayoutDate 设置为结束时间加24小时
    const handleEndChange = (value,index) => {
      onRichTextUpdate(value, `activitys[${index}].endDateTime`)
        // const { isNewTypeQuest, secondaryCreationQuest } = this.getQuestTypeFlags();
        // console.log('handleEndChange 收到值:', value);
        //
        // if (isNewTypeQuest) {
        //     // 同步设置 Close Registration Date 为 endDateTime
        //     this.props.change('closeRegistrationDate', value);
        //
        //     // 计算预计支付日期为 endDateTime 加24小时
        //     // 使用 moment 处理 ISO 字符串，确保在 UTC 时区进行运算
        //
        //     let expectedPayout = moment.utc(value)
        //         .add(24, 'hours')
        //         .toISOString();
        //     if (secondaryCreationQuest) {
        //         expectedPayout = moment.utc(value)
        //             .add(7 * 24, 'hours')
        //             .toISOString();
        //     }
        //     console.log('计算的预计支付日期:', expectedPayout);
        //     this.props.change('expectedPayoutDate', expectedPayout);
        // }
    }

  return (
    <div>
      {fields.map((step, index) => (
        <div key={index} className="faqs_wrapper">
          <button
            className="remove_faq"
            type="button"
            onClick={() => onRemove(fields, index)}
          >
            Remove Drop Activity
          </button>

          <Field
            name={`${step}.title`}
            id={`${step}.title`}
            type="text"
            component={CustomInput}
            label="Title"
            placeholder="Title"
            customLabel="Title"
          />

            <Field
                type="text"
                name={`${step}.startDateTime`}
                id={`${step}.startDateTime`}
                placeholder="Start Date"
                dateStoreFormat={DATE_STORE_FORMAT}
                dateDisplayFormat={dateDisplayFormat}
                customLabel="Start Date"
                component={CustomDateTimePicker}
                onChange={(e, v) => handleStartChange(v,index)}
            />
            <Field
                type="text"
                name={`${step}.endDateTime`}
                id={`${step}.endDateTime`}
                placeholder="End Date"
                dateStoreFormat={DATE_DISPLAY_FORMAT}
                dateDisplayFormat={dateDisplayFormat}
                customLabel="End Date"
                component={CustomDateTimePicker}
                onChange={(e, v) => handleEndChange(v,index)}
            />
        </div>
      ))}

      <button
        className="add_faq"
        type="button"
        onClick={() => fields.push({ title: null, startDateTime: null,endDateTime: null })}
      >
        Add Drop Activity
      </button>
    </div>
  );
};

DropActivitys.propTypes = {
  fields: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  onRichTextUpdate: PropTypes.func.isRequired
};

export default DropActivitys;
